import { v4 } from "uuid";
import { SET_ALERT, REMOVE_ALERT } from "./types";
import store from "../store";

export const setAlert =
  (msg, alertType, timeout = 5000, action = false, onClose = "self", refresh = false, preventDuplicate = true) =>
  (dispatch) => {
    //Get random unique id
    const id = v4();

    if (onClose) {
      if (onClose === "self") {
        onClose = () => dispatch({ type: REMOVE_ALERT, payload: id });
      }
    }

    // Check if an alert with the same message and type already exists
    if (preventDuplicate) {
      const state = store.getState();
      const existingAlert = state.alert.find((alert) => alert.msg === msg && alert.alertType === alertType);

      // If an existing alert is found, do not dispatch a new one
      if (existingAlert) {
        return;
      }
    }

    //Call SetAlert reducer with type and payload object
    dispatch({
      type: SET_ALERT,
      payload: { msg, alertType, id, action, onClose },
    });

    // After a set timeout, remove the alert (after timeout in ms, do arrow function)
    setTimeout(() => {
      dispatch({
        type: REMOVE_ALERT,
        payload: id,
      });
      if (refresh) {
        window.location.reload();
      }
    }, timeout);
  };

export const removeAlert = (id) => (dispatch) => {
  dispatch({
    type: REMOVE_ALERT,
    payload: id,
  });
};
